/**************************************************************************************************************************
 Copyright (c) 2023 WorkEarly Results LLP

     Name: assets.ts
   Author: Harikrishnan Gangadharan
 Comments: 

/**************************************************************************************************************************
 TYPES
***************************************************************************************************************************/
export interface ImageAsset {
  src: string;
  alt: string;
}
/**************************************************************************************************************************
 DEFINITIONS
***************************************************************************************************************************/
const Images: Record<string, ImageAsset> = {
  LOGO: { src: '/assets/images/logo.svg', alt: 'logo' },
  LOADING: { src: '/assets/images/loading.gif', alt: 'loading' },
  CONSTRUCTION_ICON: { src: "/assets/images/construction.png", alt: "icon" },
  COMMUNICATION_ICON: { src: "/assets/images/communication.png", alt: "icon" },
  MODERN_DESIGN_ICON: { src: "/assets/images/modern-design.png", alt: "icon" },
  ENG_CONSULTANCY_ICON: { src: "/assets/images/engineering-consultancy.png", alt: "icon" },
  ARCH_DRAWING_ICON: { src: "/assets/images/arch-drawing.png", alt: "icon" },
  MODELLING_3D_ICON: { src: "/assets/images/3d-modelling.png", alt: "icon" },
  INT_DESIGN_ICON: { src: "/assets/images/interior-designing.png", alt: "icon" },
  EXT_DESIGN_ICON: { src: "/assets/images/exterior-designing.png", alt: "icon" },
  LANDSCAPING_ICON: { src: "/assets/images/landscaping.png", alt: "icon" },
  ESTIMATION_ICON: { src: "/assets/images/estimation.png", alt: "icon" },
  RENOVATION_ICON: { src: "/assets/images/renovation.png", alt: "icon" },
  INTRO_BG: { src: "/assets/images/common/intro-bg.jpg", alt: "intro" },
  MISSION: { src: "/assets/images/about-us/mission.jpg", alt: "mission" },
  VISION: { src: "/assets/images/about-us/vision.jpg", alt: "vision" },
  IN_PROGRESS_GIF: {src: "/assets/images/contact-us/7.svg", alt: "mail-sending"},
  SUCCESS: {src: "/assets/images/contact-us/8.svg", alt: "email-sent"},
  FAILED: {src: "/assets/images/contact-us/9.svg", alt: "email-failed"},
};

const Assets = {
  Images
};

export default Assets;
